import React from 'react';

import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import classes from './styles.module.scss';
import videoIcon from '../../../assets/images/my-library/video.svg';

export default function MeetingThumbnail({ meeting }) {
  const navigate = useNavigate();

  if (!meeting) {
    return null;
  }

  const hasThumbnail = !!meeting.signedThumbnailS3FileKey;

  return (
    <div
      className={classNames(classes.MeetingThumbnail, {
        [classes.withThumbnail]: hasThumbnail,
        [classes.published]: meeting.status === 'published',
      })}
      onClick={() => {
        if (meeting.status === 'published') {
          navigate(`/my-videos/${meeting.id}`);
        }
      }}
    >
      <img
        src={meeting.signedThumbnailS3FileKey || videoIcon}
        className={classes.image}
        alt="Video"
      />
      {hasThumbnail && (
        <svg
          className={classes.playIcon}
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 28C21.7319 28 28 21.7319 28 14C28 6.26801 21.7319 0 14 0C6.26801 0 0 6.26801 0 14C0 21.7319 6.26801 28 14 28ZM12.1709 19.3841L18.7792 15.4826C19.8736 14.8364 19.8736 13.1636 18.7792 12.5174L12.1709 8.61587C11.1072 7.98785 9.8 8.80526 9.8 10.0984V17.9015C9.8 19.1947 11.1072 20.0122 12.1709 19.3841Z"
            fill="white"
          />
        </svg>
      )}
    </div>
  );
}
